import type { ReactNode } from 'react';
import { COMPACT_SEGMENTED_TOGGLE_HEIGHT_CLASS } from '../../billing/overview/CompactSegmentedToggle';
import { OverviewCard } from '../../billing/overview/OverviewCard';

interface BreakdownCardProps {
    title: string;
    info?: string;
    subtitle: string;
    // Sits on the subtitle line: a pie card is too narrow for it beside the title.
    control?: ReactNode;
    children: ReactNode;
}

// Fixed at the toggle's height, so cards with and without one keep their pies level.
function SubtitleLine({ text, control }: { text: string; control?: ReactNode }) {
    return (
        <div
            className={`flex ${COMPACT_SEGMENTED_TOGGLE_HEIGHT_CLASS} min-w-0 items-center justify-between gap-2`}
        >
            <span className="truncate text-xs text-gray-500" title={text}>
                {text}
            </span>
            {control && <div className="shrink-0">{control}</div>}
        </div>
    );
}

export function BreakdownCard({ title, info, subtitle, control, children }: BreakdownCardProps) {
    return (
        <OverviewCard
            title={title}
            info={info}
            subtitle={<SubtitleLine text={subtitle} control={control} />}
        >
            {children}
        </OverviewCard>
    );
}
